import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Button,
  Pagination,
  Typography,
  Grid,
  SvgIcon,
  Box,
  Snackbar,
  Card,
  LinearProgress,
  Paper,
  Avatar,
  useMediaQuery,
  useTheme,
  CssBaseline,
  AppBar,
  Toolbar,
  Alert,
  AlertColor,
} from "@mui/material";
import "./OnlineExamPracticeReExam.scss"; // For additional styling
import { ReactComponent as Deleteicon } from "../../Assets/Images/delete.svg";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { addExamAnswer } from "../../Redux/Slices/ExamAnswer/AddExamAnswerSlice";
import { listExamAnswer } from "../../Redux/Slices/ExamAnswer/ListExamAnswerSlice";
import { EditExamAnswer } from "../../Redux/Slices/ExamAnswer/EditExamAnswerSlice";
import { Outlet, useBlocker, useLocation, useNavigate } from "react-router-dom";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
// dialog message
import { listStudentExam } from "../../Redux/Slices/StudentExam/ListStudentExamSlice";
import { listEvaluation } from "../../Redux/Slices/Exam/ListEvaluationSlice";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { PopupStudentExam } from "../../Redux/Slices/StudentExam/PopupStudentExamSlice";
import { addCloseSection } from "../../Redux/Slices/Exam/AddCloseSectionSlice";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill CSS for styling
import { motion } from "framer-motion";
import MessageDialog from "../MessageDialog/MessageDialog";
import AlterDialog from "../AlterDialog/AlterDialog";
import ButtonField from "../Button/ButtonField";
import { listStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/ListStudentExamPracticeSlice";
import { listPracticeExamID } from "../../Redux/Slices/PracticeExam/ListPracticeExamIDSlice";
import { listExamAnswerPractice } from "../../Redux/Slices/ExamAnswerPractice/ListExamAnswerPracticeSlice";
import { addExamAnswerPractice } from "../../Redux/Slices/ExamAnswerPractice/AddExamAnswerPracticeSlice";
import { listEvaluationPractice } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import QuillEditor from "quill";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import {
  clearlistEvaluationPracticewritingExam,
  listEvaluationPracticewritingExam,
} from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import MessageDialogTest from "../MessageDialogTest/MessageDialogTest";
import InfoIcon from "@mui/icons-material/Info";
import AppBarnav from "../AppBar/AppBar";
import Loading from "../Loading/Loading";
import StatusLegend from "../StatusLegend/StatusLegent";
import { EditStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { EditStudentExam } from "../../Redux/Slices/StudentExam/EditStudentExamSlice";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { listExamsubmitPractice } from "../../Redux/Slices/ExamAnswerPractice/ListExamsubmitPracticeSlice";
import { listFlag } from "../../Redux/Slices/Falg/ListFlagSlice";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import { addFalg } from "../../Redux/Slices/Falg/AddFalgSlice";
import { CustomSnackBox } from "../CustomSnackAlert/CustomSnackBox";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface Question {
  id: number;
  question_type: string;
  prompt: string;
  instruction: string;
  subtype_name: string;
  question_id: number;
  question: string;
  question_url?: string;
  question_type_id?: number;
  options: { optionname: string; option_id: number }[];
  optionsurl: { optionname: string; option_id: number }[];
}

type ShowAlertFunction = (
  severity: AlertColor,
  message: React.ReactNode,
  duration?: number
) => void;

// Register necessary modules
const FontSize = ReactQuill.Quill.import("formats/size");
FontSize.whitelist = ["small", false, "large", "huge"];
ReactQuill.Quill.register(FontSize, true);

const Align = ReactQuill.Quill.import("formats/align");
Quill.register(Align, true);

const modules = {
  toolbar: [
    // [{ header: [false, 1, 2, 3, 4, 5, 6] }, { font: [] }], // Paragraph styles (headers) and font
    // [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    // [{ color: [] }, { background: [] }], // Text and background color
    // [{ script: "sub" }, { script: "super" }], // Subscript/superscript
    [{ list: "ordered" }, { list: "bullet" }],
    // [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    // [{ direction: "rtl" }], // Right-to-left (if needed)
    ["blockquote"],
    // ["link", "image", "formula"], // Link, image, formula
    // ["clean"], // Clear formatting
    // [{ undo: { icon: "undo" } }, { redo: { icon: "redo" } }], // Correct undo/redo
  ],
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

const formats = [
  // "header",
  // "font",
  // "size",
  "bold",
  "italic",
  "underline",
  "strike",
  // "color",
  // "background",
  "script",
  "list",
  "bullet",
  "indent",
  "direction",
  "blockquote",
  // "code-block",
  "align",
  // "link",
  // "image",
  // "formula",
];

const OnlineExamPracticeReExam: React.FC = () => {
  // overall data list
  const { data: listexamlist } = useAppSelector(
    (state) => state.ListPracticeExamIDSlice
  );
  const List: any = listexamlist;
  const ListExam: any = listexamlist;

  const navigate = useNavigate();
  const { state: exam_id } = useLocation();

  // data list  option
  const { data: listExamAnswerSlice, isLoading: answerSliceLoading } =
    useAppSelector((state) => state.ListExamAnswerPracticeSlice);
  const Listoption: any = listExamAnswerSlice?.data;

  const dispatch = useAppDispatch();

  // flag
  const { data: listflag } = useAppSelector((state) => state.ListFlagSlice);
  const { data: addflag } = useAppSelector((state) => state.AddFalgSlice);

  const flag: any = listflag?.data;
  console.log(flag);

  const [openflag, setOpenflag] = useState(false);

  const handleCloseflag = () => {
    setOpenflag(false);
  };

  const { data: listStudentExamSlice } = useAppSelector(
    (state) => state.ListStudentExamPracticeSlice
  );
  const { data: addExamAnswerRes, isLoading: addExamAnswerLoading } =
    useAppSelector((state) => state.AddExamAnswerPracticeSlice);

  const { data: editExamAnswerRes, isLoading: editExamAnswerLoading } =
    useAppSelector((state) => state.AddExamAnswerPracticeSlice);

  const ListStudentExam: any = listStudentExamSlice?.data;

  const { data: ListExamAnswerSlice } = useAppSelector(
    (state) => state.ListExamAnswerPracticeSlice
  );
  const StudentExamList: any = ListExamAnswerSlice?.data;

  // dialog  list
  const [openmessage, setOpenmessage] = React.useState(false);
  // //   dialog box
  // const [open, setOpen] = React.useState(false);
  // const toggleDrawer = (newOpen: boolean) => () => {
  //   setOpen(newOpen);
  // };

  // const handleClose = () => {
  //   setOpenmessage(false);
  //   setOpen(true);
  //   setIsSubmitted(false);
  // };

  function handleListItemClick(question_type_id: number) {
    // Find the index of the first question with the matching question_type_id
    const questionIndex = List?.data?.questions.findIndex(
      (question: any) => question.question_type_id === question_type_id
    );
    setCurrentQuestion(questionIndex + 1);
  }

  useEffect(() => {
    dispatch(listStudentExamPractice());
  }, []);

  useEffect(() => {
    dispatch(listPracticeExamID({ student_test_id: ListStudentExam?.id }));
  }, [ListStudentExam]);

  const [questions, setQuestions] = useState<Question[]>([]); // Initialize with predefined data

  const [currentQuestionTypeIndex, setCurrentQuestionTypeIndex] =
    useState<number>(
      parseInt(sessionStorage.getItem("sectionreexamId") ?? "0") ?? 0
    ); // Tracks current question type

  useEffect(() => {
    // setSearchParams({ id: encode(currentQuestionTypeIndex) });
    sessionStorage.setItem(
      "sectionreexamId",
      currentQuestionTypeIndex.toString()
    );
  }, [currentQuestionTypeIndex]);

  useEffect(() => {
    !!sessionStorage.getItem("sectionreexamId") &&
      setCurrentQuestionTypeIndex(
        parseInt(sessionStorage.getItem("sectionreexamId")!)
      );
  }, []);

  function formatTime(timeInSeconds: number) {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60; // exact seconds

    let result = "";

    if (hours > 0) {
      result += `${hours} hour${hours !== 1 ? "s" : ""} `;
    }

    if (minutes > 0) {
      result += `${minutes} minute${minutes !== 1 ? "s" : ""} `;
    }

    // Always show seconds (even if zero)
    result += `${seconds} second${seconds !== 1 ? "s" : ""}`;

    return result.trim();
  }
  // const TimeList:any = formatTime(timeLeft)

  const currentType = List?.data?.question_by_type?.[currentQuestionTypeIndex];

  const [timeget, Settimeget] = useState(
    currentType?.total_timing ||
      formatTime(parseInt(sessionStorage.getItem("remain_time") ?? "5 minutes"))
  );

  function convertToSeconds(time: string): number {
    if (!time) return 0;

    // Case MM:SS
    if (time.includes(":")) {
      const [m, s] = time.split(":").map(Number);
      return (m || 0) * 60 + (s || 0);
    }

    // Case decimal minutes like "8.40 minutes"
    if (time.includes("minute")) {
      const numStr = time.split(" ")[0]; // "8.40"
      const [mStr, sStr] = numStr.split("."); // mStr="8", sStr="40"

      const minutes = Number(mStr);

      // Handle decimals properly: 8.40 means 8 min 40 sec
      const seconds = sStr ? Number(sStr) : 0;

      return minutes * 60 + seconds;
    }

    // Case hours
    if (time.includes("hour")) {
      const num = parseFloat(time);
      return Math.floor(num * 3600);
    }

    // Fallback plain seconds
    const num = Number(time);
    return isNaN(num) ? 0 : num;
  }

  const saved = sessionStorage.getItem("remain_time");

  const [timeLeft, setTimeLeft] = useState<number>(
    saved ? convertToSeconds(saved) : convertToSeconds(timeget)
  );

  useEffect(() => {
    const currentType =
      List?.data?.question_by_type?.[currentQuestionTypeIndex];

    if (currentType?.questions) {
      const firstQuestionType = currentType?.questions?.map(
        (question: any) => ({
          id: question?.question_id,
          question_type: question?.question_type_name,
          question_type_id: question?.question_type_id,
          question_id: question?.question_id,
          question_url: question?.question_url,
          question: question?.question_text,
          prompt: question?.prompt,
          subtype_name: question?.subtype_name,
          instruction: question?.instruction,
          options: question?.options?.map((opt: any) => ({
            optionname: opt?.option_text,
            option_id: opt?.option_id,
          })),
          optionsurl: question?.options?.map((opt: any) => ({
            optionname: opt?.option_url === null ? null : opt?.option_url,
            option_id: opt?.option_id,
          })),
        })
      );
      setQuestions(firstQuestionType);
    } else {
      console.warn(
        `No questions found for question type index: ${currentQuestionTypeIndex}`
      );
      setQuestions([]); // Reset questions state if no data
    }
    // time set
    if (currentType?.total_timing) {
      const minutes = currentType?.total_timing || "3 minutes";
      Settimeget(minutes);
    }
  }, [List, currentQuestionTypeIndex]);

  // const [currentQuestion, setCurrentQuestion] = useState<number>(1);
  // const [selectedAnswers, setSelectedAnswers] = useState<{
  //   [sectionIndex: number]: { [questionId: number]: string | null };
  // }>({});

  const [currentQuestion, setCurrentQuestion] = useState(1); // Tracks current question (pagination)
  const [selectedAnswersOption, setSelectedAnswersOption] = useState<
    Record<number, Record<number, number>>
  >({});

  const [selectedAnswers, setSelectedAnswers] = useState<{
    [key: number]: string | null;
  }>({});

  const [isExamOver, setIsExamOver] = useState<boolean>(false);
  const [istimeOver, setIstimeOver] = useState<boolean>(false);
  const [istimeOvers, setIstimeOvers] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  // Section List
  const [isSection, setIsSection] = useState<boolean>(false);
  const [isSectionnext, setIsSectionnext] = useState<boolean>(false);

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    // All routes that should be allowed from exam results
    const allowedRoutes = [
      "/practicetest",
      "/dashboard",
      "/examresultpractice",
    ];

    const currentPath = currentLocation.pathname;
    const nextPath = nextLocation.pathname;

    // Don't block if staying on same page or going to allowed routes
    if (currentPath === nextPath || allowedRoutes.includes(nextPath)) {
      return false;
    }

    // Permanently block everything else
    return true;
  });

  useEffect(() => {
    if (blocker.state === "blocked") {
      blocker.reset();
    }
  }, [blocker]);

  useEffect(() => {
    // Reset time when question type changes
    if (currentType?.total_timing) {
      const newTimeLeft = convertToSeconds(currentType.total_timing);
      setTimeLeft(newTimeLeft);
    }
  }, [currentQuestionTypeIndex]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    const handleTabChange = () => {
      if (document.hidden) {
        setIstimeOvers(true);
      }
    };
    document.addEventListener("visibilitychange", handleTabChange);

    const preventCopyPaste = (e: ClipboardEvent) => {
      e.preventDefault();
    };
    document.addEventListener("copy", preventCopyPaste);
    document.addEventListener("cut", preventCopyPaste);
    document.addEventListener("paste", preventCopyPaste);

    // Disable spellcheck, autocorrect, autocapitalize, and Grammarly
    const disableTextFieldAttributes = () => {
      const inputs = document.querySelectorAll("input, textarea");
      inputs.forEach((input) => {
        input.setAttribute("spellcheck", "false");
        input.setAttribute("autocorrect", "off");
        input.setAttribute("autocapitalize", "off");
        input.setAttribute("data-gramm", "false"); // Grammarly
      });
    };
    disableTextFieldAttributes();

    if (timeLeft === 0) {
      setIstimeOver(true);
      // clearInterval(timer);
    }
    sessionStorage.setItem("remain_time", timeLeft.toString());
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", handleTabChange);
      document.removeEventListener("copy", preventCopyPaste);
      document.removeEventListener("cut", preventCopyPaste);
      document.removeEventListener("paste", preventCopyPaste);
    };
  }, [timeLeft]);

  useEffect(() => {
    const handleContextmenu = (e: any) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextmenu);
    return function cleanup() {
      document.removeEventListener("contextmenu", handleContextmenu);
    };
  }, []);

  // is for section pagenation
  useEffect(() => {
    setCurrentQuestion(1); // Reset to the first question in the new section
  }, [currentQuestionTypeIndex]);

  const handleAnswerSelect = (questionId: number, option: string) => {
    setSelectedAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: option,
    }));
  };

  const clearSelection = useCallback(() => {
    // Clear from selectedAnswers (set to null instead of delete for consistency)
    setSelectedAnswers((prev) => ({
      ...prev,
      [currentQuestion]: null,
    }));

    // Clear from selectedAnswersOption
    setSelectedAnswersOption((prev) => {
      const newState = { ...prev };

      // If this section exists in state
      if (newState[currentQuestionTypeIndex]) {
        // Create a new object for this section to ensure immutability
        newState[currentQuestionTypeIndex] = {
          ...newState[currentQuestionTypeIndex],
        };
        // Remove the current question's answer
        delete newState[currentQuestionTypeIndex][currentQuestion];

        // If section is now empty, remove it
        if (Object.keys(newState[currentQuestionTypeIndex]).length === 0) {
          delete newState[currentQuestionTypeIndex];
        }
      }

      return newState;
    });

    setShowClearAlert(true);
  }, [currentQuestion, currentQuestionTypeIndex]);

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    // Do submit actions here...
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [wordCount, setWordCount] = useState(0);
  const [remainingWords, setremainingWords] = useState(0);
  const [characterCount, setCharacterCount] = useState(0);
  const [sentenceCount, setSentenceCount] = useState(0);
  const [paragraphCount, setParagraphCount] = useState(0);

  // Text Editor
  const [editorValue, setEditorValue] = useState<string>(""); // State to store editor value

  const handleChange = (content: any) => {
    // Remove HTML tags and trim whitespace
    const textContent = content?.replace(/<[^>]+>/g, "")?.trim();
    const words = textContent?.split(/\s+/); // Split into words

    // Enforce max word limit (10 words)

    setEditorValue(content);
    setWordCount(words?.length);

    const remainingWords = 120 - (words?.length || 0);
    setremainingWords(remainingWords);

    // Character count (excluding spaces)
    const characterCount = textContent?.replace(/\s+/g, "")?.length;
    setCharacterCount(characterCount);

    // Sentence count
    const sentences = textContent
      ?.split(/[.!?]+/)
      .filter((sentence: any) => sentence?.trim()?.length > 0);
    setSentenceCount(sentences.length);

    // Paragraph count
    const paragraphs = textContent
      ?.split(/\n+/)
      .filter((para: any) => para?.trim()?.length > 0);
    setParagraphCount(paragraphs?.length);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isOptionSelected =
    !!selectedAnswersOption[currentQuestionTypeIndex]?.[currentQuestion];

  // option list
  const renderQuestionOptions = (
    questionId: number,
    question_type: string,
    options: { optionname: string; option_id: number }[],
    optionsurl: {
      optionname: string;
      option_id: number;
    }[] // Assuming you want to access option_url
  ) => {
    const hasNullUrl = optionsurl.some((option) => option.optionname === null);
    const height = isMobile ? "40vh" : isTablet ? "70vh" : "70vh";

    return (
      <Grid
        container
        spacing={3}
        sx={{
          ...(question_type === "Reading Comprehension" ||
          question_type === "Writing"
            ? {
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }
            : {
                margin: "0px",
              }),
        }}
      >
        {question_type === "Writing" ? (
          <>
            <ReactQuill
              className="custom-quill"
              style={{
                width: "100%",
                padding: "20px 0px 20px 8px",
                height: height,
              }}
              theme="snow"
              value={editorValue}
              onChange={handleChange}
              modules={modules}
              formats={formats}
              tabIndex={0} // Ensure it's focusable without enabling spellcheck
              placeholder="Write something here..."
              preserveWhitespace
              data-gramm="false"
              onFocus={() => {
                // Ensure the underlying contenteditable disables spellcheck and autocorrect
                const editorElement = document.querySelector(".ql-editor");
                if (editorElement) {
                  editorElement.setAttribute("spellcheck", "false");
                  editorElement.setAttribute("autocorrect", "off");
                  editorElement.setAttribute("autocapitalize", "off");
                  editorElement.setAttribute("data-gramm", "false"); // Disable Grammarly
                }
              }}
            />
          </>
        ) : hasNullUrl ? (
          options.map((option, index) => {
            const isSelected =
              selectedAnswersOption[currentQuestionTypeIndex]?.[
                currentQuestion
              ] === option.option_id;

            return (
              <Grid item xs={6} key={index} className="gridwidth">
                <Box
                  onClick={() => {
                    setSelectedAnswersOption((prev) => ({
                      ...prev,
                      [currentQuestionTypeIndex]: {
                        ...(prev[currentQuestionTypeIndex] || {}),
                        [currentQuestion]: option.option_id,
                      },
                    }));
                    handleAnswerSelect(questionId, option.optionname);
                  }}
                  sx={{
                    border: isSelected
                      ? "1.2px solid #009dff"
                      : "1px solid #CDCDCD",
                    borderRadius: "10px",
                    padding:
                      question_type === "Reading Comprehension"
                        ? "10px"
                        : "8px",
                    cursor: "pointer",
                    textAlign: "left",
                    fontSize: "15px",
                    minHeight: "50px",
                    height: "100%",
                    width: "100%",
                    backgroundColor: isSelected ? "#EFF6FF" : "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: isSelected ? "#EFF6FF" : "#f5f5f5",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      minWidth: 28,
                      borderRadius: "50%",
                      backgroundColor: isSelected ? "#009dff" : "#F0F1F7",
                      color: isSelected ? "#fff" : "#000",
                      fontWeight: "500",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                    }}
                  >
                    {String.fromCharCode(65 + index)}
                  </Box>

                  {/* Option Text */}
                  <Box
                    component="span"
                    sx={{
                      color: isSelected ? "#333" : "#000",
                      fontWeight: 500,
                      fontSize: "16px",
                    }}
                  >
                    {option.optionname}
                  </Box>
                </Box>
              </Grid>
            );
          })
        ) : (
          optionsurl.map((option, index) => {
            const isSelected =
              selectedAnswersOption[currentQuestionTypeIndex]?.[
                currentQuestion
              ] === option.option_id;

            return (
              <Grid item xs={6} key={index} className="gridwidth">
                <Box
                  onClick={() => {
                    setSelectedAnswersOption((prev) => ({
                      ...prev,
                      [currentQuestionTypeIndex]: {
                        ...(prev[currentQuestionTypeIndex] || {}),
                        [currentQuestion]: option.option_id,
                      },
                    }));
                    handleAnswerSelect(questionId, option.optionname);
                  }}
                  sx={{
                    border: isSelected
                      ? "1.2px solid #009dff"
                      : "1px solid #CDCDCD",
                    borderRadius: "10px",
                    padding:
                      question_type === "Reading Comprehension"
                        ? "10px"
                        : "8px",
                    cursor: "pointer",
                    textAlign: "left",
                    fontSize: "15px",
                    backgroundColor: isSelected ? "#EFF6FF" : "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: isSelected ? "#EFF6FF" : "#f5f5f5",
                    },
                  }}
                >
                  {/* Circle Label (A, B, C, D) */}
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      minWidth: 28,
                      borderRadius: "50%",
                      backgroundColor: isSelected ? "#009dff" : "#F0F1F7",
                      color: isSelected ? "#fff" : "#000",
                      fontWeight: "500",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: 2,
                    }}
                  >
                    {String.fromCharCode(65 + index)}
                  </Box>

                  {/* Option Image */}
                  <Box
                    component="img"
                    src={option.optionname}
                    alt={`Option ${index + 1}`}
                    sx={{
                      maxWidth: "100%",
                      maxHeight: "60px",
                      objectFit: "contain",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
              </Grid>
            );
          })
        )}
      </Grid>
    );
  };

  const [previousTotal, setPreviousTotal] = useState<number>(0);
  // To get the selected option for the current question
  const selectedOptionForCurrentQuestion: any =
    selectedAnswers[currentQuestion];
  // const selectedOptionForCurrentQuestion =
  //   selectedAnswers[currentQuestion]?.[questions[currentQuestion - 1]?.id]; // Access the specific option as a string

  const filterquestionlist = Listoption?.filter((data: any) => {
    return data?.question_id === questions[currentQuestion - 1]?.id;
  });

  // Check if selectedOptionForCurrentQuestion is a URL (blob or regular URL)
  const isUrl =
    selectedOptionForCurrentQuestion?.startsWith("https://") ||
    selectedOptionForCurrentQuestion?.startsWith("http://");

  // Use the appropriate filter based on whether it's a URL or not
  const selectedOptionFilterValue = isUrl
    ? questions[currentQuestion - 1]?.optionsurl?.filter(
        (option) => selectedOptionForCurrentQuestion === option.optionname
      )
    : questions[currentQuestion - 1]?.options?.filter(
        (option) => selectedOptionForCurrentQuestion === option.optionname
      );

  // question image show
  const imageFile = questions[currentQuestion - 1]?.question_url;

  const questionTypesCount = questions.reduce((acc: any, curr: any) => {
    const type = curr.question_type;
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  // function calculateBalance(
  //   questions: { [key: string]: number },
  //   currentType: string
  // ) {
  //   // Get the count for the current question type
  //   const currentQuestions = questions[currentType] || 0;
  //   // Update the previous total by adding the current question type count
  //   const updatedTotal = previousTotal + currentQuestions;

  //   // Update the state with the new total
  //   setPreviousTotal(updatedTotal);
  // }

  useEffect(() => {
    // alert("hi");
  }, [questions[currentQuestion - 1]?.question_type]);

  useEffect(() => {
    dispatch(
      listExamAnswerPractice({
        student_test_id: ListStudentExam?.id,
      })
    );
  }, [addExamAnswerRes, editExamAnswerRes]);
  // useEffect(() => {
  //   if (
  //     !answerSliceLoading &&
  //     !addExamAnswerLoading &&
  //     !editExamAnswerLoading &&
  //     isSubmitted
  //   ) {
  //     const sectionlist = List?.data?.questions_by_type?.map(
  //       (questionType: any) => {
  //         const { question_type_id, question_type_name, question_count } =
  //           questionType;

  //         // Filter data to count and check for skipped questions for this question type
  //         const matchingQuestions = StudentExamList?.filter(
  //           (item: any) => item?.questionType_id === question_type_id
  //         );
  //         const actualCount = matchingQuestions?.length;
  //         const skippedCount = matchingQuestions?.filter(
  //           (item: any) => item?.skipped
  //         ).length;

  //         // Determine if this type has pending questions
  //         const hasPending = actualCount !== question_count || skippedCount > 0;
  //         return hasPending;
  //       }
  //     );

  //     if (sectionlist.includes(true)) {
  //       setOpenmessage(true);
  //     } else {
  //       setIsExamOver(true);
  //       setOpenmessage(false);
  //     }
  //   }
  // }, [addExamAnswerRes, editExamAnswerRes, listExamAnswerSlice, isSubmitted]);

  // timeing method
  const timing = `${Math.floor(timeLeft / 60)}:${String(timeLeft % 60).padStart(
    2,
    "0"
  )}`;
  const [lastMinters, setLastMinters] = useState<boolean>(false);
  const [anchorPosition, setAnchorPosition] = useState<{
    vertical: "top" | "bottom";
    horizontal: "left" | "center" | "right";
  }>({
    vertical: "top",
    horizontal: "right",
  });

  useEffect(() => {
    sessionStorage.setItem(
      "question_type",
      questions[currentQuestion - 1]?.question_type_id?.toString() ?? ""
    );
    sessionStorage.setItem(
      "question_id",
      questions[currentQuestion - 1]?.question_id?.toString() ?? ""
    );
    sessionStorage.setItem("response", editorValue);
    sessionStorage.setItem("pending_time", timing);
    sessionStorage.setItem("student_exam_id", ListStudentExam?.id);
    if (timing === "3:00") {
      // This function should be called when timing is "5:00"
      const newPosition: any = { vertical: "top", horizontal: "right" };
      setAnchorPosition(newPosition); // Set the position for the Snackbar
      setLastMinters(true); // Open the Snackbar
    }
  }, [timing]);

  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [questions[currentQuestion - 1]?.id]);

  // Reload  page

  const [showModal, setShowModal] = useState(false);
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    // Prevent the default unload action and show the modal
    setShowModal(true);
    event.preventDefault();
    // Return empty string for some browsers (like Chrome) to display the confirmation dialog
    // event.returnValue = "";
  };
  useEffect(() => {
    const beforeUnloadListener = (event: BeforeUnloadEvent) =>
      handleBeforeUnload(event);
    window.addEventListener("beforeunload", beforeUnloadListener);
    return () => {
      window.removeEventListener("beforeunload", beforeUnloadListener);
    };
  }, []);

  // timesubmit report
  const { data: EvaluationPracticewritingExam, isLoading: Evaluationlist } =
    useAppSelector((state) => state.ListEvaluationPracticewritingExamSlice);

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (Evaluationlist === true) {
      setLoading(true);
    }
  }, [Evaluationlist === true]);

  useEffect(() => {
    if (EvaluationPracticewritingExam?.status) {
      navigate("/examresultpractice", {
        state: {
          id: ListStudentExam?.id,
          type: "Writing",
        },
      });
    }
  }, [EvaluationPracticewritingExam]);

  // zooming
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  const toggleZoom = (event: React.MouseEvent) => {
    if (scale === 1) {
      setScale(2); // Zoom in

      // Center the zoom around the click position
      const rect = event.currentTarget.getBoundingClientRect();
      setPosition({
        x: (rect.width / 2 - event.clientX) / 1.5,
        y: (rect.height / 2 - event.clientY) / 1.5,
      });
    } else {
      setScale(1); // Reset zoom
      setPosition({ x: 0, y: 0 }); // Reset position
    }
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    if (scale === 1) return; // Only allow dragging when zoomed in
    setDragging(true);
    setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!dragging) return;

    // Prevent the image from going too far outside
    const newX = e.clientX - start.x;
    const newY = e.clientY - start.y;

    setPosition({ x: newX, y: newY });
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const progress = (currentQuestion / questions?.length) * 100;

  // appabar

  const nav = useNavigate();

  const [ishome, setIshome] = useState<boolean>(false);
  const [istest, setIstest] = useState<boolean>(false);
  const PendingTime = sessionStorage.getItem("pending_time");
  const Response = sessionStorage.getItem("response");
  const question_id = Number(sessionStorage.getItem("question_id"));
  const Question_Type = Number(sessionStorage.getItem("question_type"));
  const StudentExamId = Number(sessionStorage.getItem("student_exam_id"));

  const handleAnswerBeforeNavigation = (newQuestion: number) => {
    const currentQuestionData = questions[currentQuestion - 1];
    const optionId = selectedOptionFilterValue?.[0]?.option_id ?? null;
    const isSkipped = !optionId;

    const payload = {
      student_test_id: ListStudentExam?.id,
      question_id: currentQuestionData?.id,
      option_id: optionId,
      remaining_time: timing,
      skipped: isSkipped,
      question_type_id: currentQuestionData?.question_type_id,
      question_start_time: questionStartTime,
      question_end_time: new Date().toISOString(),
    };

    if (filterquestionlist?.length > 0 && filterquestionlist[0]?.id) {
      dispatch(
        addExamAnswerPractice({ id: filterquestionlist[0]?.id, ...payload })
      );
    } else {
      dispatch(addExamAnswerPractice(payload));
    }

    // Then move to the new question
    setCurrentQuestion(newQuestion);
  };

  // popup message
  const { data: listExamsubmitSlice } = useAppSelector(
    (state) => state.ListExamsubmitPracticeSlice
  );
  const Add: any = listExamsubmitSlice?.data;

  // time  based
  const [questionStartTime, setQuestionStartTime] = useState<string>(
    new Date().toISOString()
  );

  useEffect(() => {
    // Set start time when question changes
    setQuestionStartTime(new Date().toISOString());
  }, [currentQuestion]);

  useEffect(() => {
    dispatch(
      listFlag({
        student_test_id: ListStudentExam?.id,
      })
    );
    setOpenflag(false);
  }, [addflag, ListStudentExam?.id]);

  const flaggedMap = new Map<number, boolean>(
    flag
      ?.filter((item: { flagged: boolean }) => item.flagged)
      .map((item: { question_id: number }) => [item.question_id, true])
  );

  const isFlagged = flaggedMap.has(questions[currentQuestion - 1]?.question_id);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      const isTyping =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable;

      if (
        isTyping ||
        questions[currentQuestion - 1]?.question_type === "Writing"
      ) {
        return;
      }

      switch (event.key) {
        case "ArrowLeft":
          if (currentQuestion > 1) {
            handleAnswerBeforeNavigation(currentQuestion - 1);
          }
          break;

        case "ArrowRight":
          if (currentQuestion < questions?.length) {
            // Navigate to next question
            handleAnswerBeforeNavigation(currentQuestion + 1);
          } else if (currentQuestion === questions?.length) {
            // On last question, trigger submit if it's the last section
            if (
              currentQuestionTypeIndex <
              List?.data?.question_by_type?.length - 1
            ) {
              // Move to next section
              setCurrentQuestionTypeIndex((prev) => prev + 1);
              setCurrentQuestion(1);
            } else {
              // Submit the test (same logic as the submit button)
              const currentTime = new Date().toISOString();

              if (
                List?.data?.question_by_type[0]?.question_type_name !==
                "Writing"
              ) {
                const payload = {
                  student_test_id: ListStudentExam?.id,
                  question_id: questions[currentQuestion - 1]?.id,
                  option_id: selectedOptionFilterValue?.[0]?.option_id ?? null,
                  remaining_time: timing,
                  skipped: !selectedOptionFilterValue?.[0]?.option_id,
                  question_type_id:
                    questions[currentQuestion - 1]?.question_type_id,
                  question_start_time: questionStartTime,
                  question_end_time: currentTime,
                };

                if (
                  filterquestionlist?.length > 0 &&
                  filterquestionlist[0]?.id
                ) {
                  dispatch(
                    addExamAnswerPractice({
                      id: filterquestionlist[0]?.id,
                      ...payload,
                    })
                  );
                } else {
                  dispatch(addExamAnswerPractice(payload));
                }
              }

              dispatch(listExamsubmitPractice({ id: ListStudentExam?.id }));
              setIsSubmitted(true);
            }
          }
          break;

        case "c":
        case "C":
          event.preventDefault();
          // Only clear selection if there's an answer to clear
          if (selectedOptionFilterValue?.[0]?.option_id) {
            clearSelection();
          }
          break;

        case "f":
        case "F":
          event.preventDefault();
          if (questions[currentQuestion - 1]?.id && ListStudentExam?.id) {
            dispatch(
              addFalg({
                student_test_id: ListStudentExam.id,
                question_id: questions[currentQuestion - 1].id,
              })
            );
            setOpenflag(true);
          }
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    currentQuestion,
    questions,
    selectedOptionFilterValue, // This dependency is now used in the 'c' case
    filterquestionlist,
    ListStudentExam?.id,
    timing,
    questionStartTime,
    dispatch,
    currentQuestionTypeIndex,
    List?.data?.question_by_type,
    clearSelection, // Make sure this is included in dependencies if it's defined outside
  ]);

  const [showClearAlert, setShowClearAlert] = useState(false);
  const [showUnflagAlert, setShowUnflagAlert] = useState(false);

  const SnackTriggerHandler: React.FC<{
    showAlert: ShowAlertFunction;
    openflag: boolean;
    setOpenflag: React.Dispatch<React.SetStateAction<boolean>>;
    showClearAlert: boolean;
    setShowClearAlert: React.Dispatch<React.SetStateAction<boolean>>;
    showUnflagAlert: boolean;
    setShowUnflagAlert: React.Dispatch<React.SetStateAction<boolean>>;
    isFlagged: boolean;
  }> = ({
    showAlert,
    openflag,
    setOpenflag,
    showClearAlert,
    setShowClearAlert,
    showUnflagAlert,
    setShowUnflagAlert,
    isFlagged,
  }) => {
    React.useEffect(() => {
      if (openflag) {
        showAlert(
          "success",
          <>
            <strong style={{ fontSize: "14px" }}>
              {isFlagged ? "Question unflagged" : "Question flagged"}
            </strong>
            <br />
            {isFlagged
              ? "This question is no longer flagged for review."
              : "You've flagged this question for review."}
          </>,
          1000
        );
        setOpenflag(false);
      }
    }, [openflag, showAlert, setOpenflag, isFlagged]);

    React.useEffect(() => {
      if (showClearAlert) {
        showAlert(
          "success",
          <>
            <strong style={{ fontSize: "14px" }}>Answer cleared</strong>
            <br />
            Your selection has been removed.
          </>,
          1000
        );
        setShowClearAlert(false);
      }
    }, [showClearAlert, showAlert, setShowClearAlert]);

    React.useEffect(() => {
      if (showUnflagAlert) {
        showAlert(
          "success",
          <>
            <strong style={{ fontSize: "14px" }}>Question unflagged</strong>
            <br />
            This question is no longer flagged for review.
          </>,
          1000
        );
        setShowUnflagAlert(false);
      }
    }, [showUnflagAlert, showAlert, setShowUnflagAlert]);

    return null;
  };

  return (
    <>
      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar
            sx={{
              minHeight: "0px",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "0px",
              paddingRight: "0px",
              margin:
                questions[currentQuestion - 1]?.question_type === "Writing"
                  ? "0% 0.5%"
                  : "0% 3%",
              height: "50px",
            }}
          >
            <Typography variant="h6" noWrap component="div">
              <SvgIcon
                sx={{
                  width: "123px",
                  height: "50px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                color="primary"
                component={Logo}
                inheritViewBox
                onClick={() => {
                  setIshome(true);
                }}
              />
            </Typography>
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  color: "#009dff",
                  fontSize: "16px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setIshome(true);
                  setIstest(true);
                }}
              >
                <ArrowBackIosIcon sx={{ color: "#009dff" }} />
                <div style={{ color: "#009dff", fontSize: "16px" }}>
                  {" "}
                  Back to Tests
                </div>
              </div>
              <div className="onlineexamtime">
                <AccessTimeIcon sx={{ marginRight: "5px" }} />{" "}
                {Math.floor(timeLeft / 60)}:
                {String(timeLeft % 60).padStart(2, "0")}
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
        </Box>
      </Box>
      <AlterDialog
        alterheading={"Warning"}
        alterableName={
          "You are currently in the middle of the examination. Please complete it and move forward, or resume the exam from the 'Exams in Progress' section until time is up"
        }
        open={ishome}
        setOpen={setIshome}
        buttonname={
          <>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                if (exam_id?.Practice) {
                  dispatch(
                    EditStudentExamPractice({
                      pending_time: PendingTime,
                      student_test_id: StudentExamId,
                      question_type_id: Question_Type,
                      question_id: question_id,
                      response: Response,
                    })
                  );
                } else {
                  dispatch(
                    EditStudentExam({
                      pending_time: PendingTime,
                      student_exam_id: StudentExamId,
                      question_type_id: Question_Type,
                      question_id: question_id,
                      sentence: Response,
                    })
                  );
                }
                sessionStorage.removeItem("pending_time");
                sessionStorage.removeItem("response");
                sessionStorage.removeItem("question_id");
                sessionStorage.removeItem("question_type");
                sessionStorage.removeItem("student_exam_id");

                const targetPath = istest ? "/practicetest" : "/dashboard";

                nav(targetPath);
                setIshome(false);
                setIstest(false);
              }}
            >
              Yes
            </ButtonField>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setIshome(false);
                setIstest(false);
              }}
            >
              No
            </ButtonField>
          </>
        }
      />{" "}
      <div style={{ height: "50px" }} />
      {loading && <Loading isLoading={loading} />}
      <div className="unselectable" style={{ backgroundColor: "#fffaf5ff" }}>
        <div
          ref={scrollRef}
          style={{
            display: "flex",
            color: "#1e3a8a",
            fontWeight: 700,
            fontSize: "24px",
            padding: "5px 0px",
            margin:
              questions[currentQuestion - 1]?.question_type === "Writing"
                ? "2% 1% 0.5%"
                : "2% 4.5% 0.5% 4.5%",
            alignItems: "center",
          }}
        >
          {List?.data?.test_name}
          {/* {questions[currentQuestion - 1]?.question_type} */}
          {/* {questions[currentQuestion - 1]?.subtype_name !== null && (
            <div
              style={{
                textTransform: "capitalize",
                color: "#1e3a8a",
                fontWeight: 700,
                fontSize: "24px",
              }}
            >
              &nbsp; : &nbsp;{questions[currentQuestion - 1]?.subtype_name}
            </div>
          )} */}
          <span
            style={{
              color: "#009dff",
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              marginTop: "6px",
              fontWeight: "500",
            }}
          >
            &nbsp; • Question {currentQuestion} of {""}
            {questions?.length}{" "}
          </span>
        </div>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            margin:
              questions[currentQuestion - 1]?.question_type === "Writing"
                ? "0% 1%"
                : "0% 4.5% 1%",
            padding: "5px",
            borderRadius: "10px",
          }}
        />
        {questions[currentQuestion - 1]?.question_type === "Writing" ? null : (
          <div style={{ margin: "0.5% 4.5%" }}>
            {/* <Pagination
              count={questions.length} // Total number of questions
              variant="outlined"
              siblingCount={6} // Display 5 sibling pages
              boundaryCount={1} // Show 3 boundary pages
              page={currentQuestion} // Current active page
              onChange={(event, value) => setCurrentQuestion(value)} // Update `currentQuestion` on page change
              renderItem={(item: any) => {
                if (item.type === "previous" || item.type === "next")
                  return null;

                // Check if the current page has an answer
                const currentSectionAnswers =
                  selectedAnswersOption[currentQuestionTypeIndex] || {};
                const isAnswered = Boolean(currentSectionAnswers[item.page]);
                const color = isAnswered
                  ? "linear-gradient(to right, #00aaff, #88e1ff)"
                  : "#9CA3AF";
                // testing
                return (
                  <Button
                    key={item.page}
                    sx={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "50%",
                      color: "white",
                      background:
                        item.page === currentQuestion
                          ? "linear-gradient(to right, #00aaff, #88e1ff)"
                          : color,
                      minWidth: "unset",
                      padding: 0,
                      marginLeft: "5px",
                      marginTop: "3px",
                      fontSize: "17px",
                      transition: "background 0.2s, opacity 0.2s",
                      "&:hover": {
                        backgroundColor:
                          item.page === currentQuestion ? "#4dc4ff" : "#d1d5db", // slightly duller gray
                        opacity: item.page === currentQuestion ? 1 : 0.8, // slightly faded if gray
                      },
                    }}
                    onClick={() => setCurrentQuestion(item.page)}
                  >
                    {item.page}
                  </Button>
                );
              }}
            /> */}

            <Pagination
              count={questions.length}
              variant="outlined"
              siblingCount={6}
              boundaryCount={1}
              page={currentQuestion}
              onChange={(event, value) => {
                if (value !== currentQuestion) {
                  handleAnswerBeforeNavigation(value);
                }
              }}
              renderItem={(item: any) => {
                if (item.type === "previous" || item.type === "next")
                  return null;
                if (
                  item.type === "start-ellipsis" ||
                  item.type === "end-ellipsis"
                ) {
                  return (
                    <Box
                      key={item.type + item.page}
                      sx={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "50%",
                        backgroundColor: "#9CA3AF",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "5px",
                        marginTop: "3px",
                        fontSize: "20px",
                        color: "white",
                        userSelect: "none",
                      }}
                    >
                      …
                    </Box>
                  );
                }

                const questionIndex = item.page - 1; // pages are 1-based
                const question = questions[questionIndex];
                const isFlagged = flaggedMap.has(question?.question_id);

                const currentSectionAnswers =
                  selectedAnswersOption[currentQuestionTypeIndex] || {};
                const isAnswered = Boolean(currentSectionAnswers[item.page]);

                const backgroundColor =
                  item.page === currentQuestion
                    ? "linear-gradient(to right, #00aaff, #88e1ff)" // Current question
                    : isFlagged
                    ? "#ffffff" // White background for flagged questions
                    : isAnswered
                    ? "#bfdbfe" // Answered but not flagged
                    : "#9CA3AF"; // Default gray

                return (
                  <Box
                    key={item.page}
                    position="relative"
                    display="inline-block"
                  >
                    <Button
                      sx={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "50%",
                        color:
                          isFlagged && item.page !== currentQuestion
                            ? "#f97316"
                            : isAnswered
                            ? "#009dff"
                            : isFlagged && item.page === currentQuestion
                            ? "#ffff"
                            : "white",
                        background: backgroundColor,
                        minWidth: "unset",
                        padding: 0,
                        marginLeft: "5px",
                        marginTop: "3px",
                        fontSize: "17px",
                        transition: "background 0.2s, opacity 0.2s",
                        border:
                          isFlagged && isAnswered
                            ? "2px solid #f97316"
                            : isFlagged && item.page !== currentQuestion
                            ? "2px solid #f97316"
                            : isFlagged && item.page === currentQuestion
                            ? "none"
                            : "none",
                        "&:hover": {
                          backgroundColor:
                            item.page === currentQuestion
                              ? "#4dc4ff"
                              : "#d1d5db",
                          opacity: item.page === currentQuestion ? 1 : 0.8,
                        },
                      }}
                      onClick={() => {
                        if (item.page !== currentQuestion) {
                          handleAnswerBeforeNavigation(item.page);
                        }
                      }}
                    >
                      {item.page}
                    </Button>
                    {isFlagged && (
                      <FlagOutlinedIcon
                        sx={{
                          backgroundColor: "#f97316",
                          color: "white",
                          position: "absolute",
                          top: "-8px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          fontSize: "18px",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </Box>
                );
              }}
            />
            <StatusLegend />
          </div>
        )}

        {questions[currentQuestion - 1]?.question_type ===
        "Reading Comprehension" ? (
          <>
            <Card
              sx={{
                m: 2,
                borderRadius: "20px",
                // height: "100%",
                margin: "0px 4% 10px 4%",
                overflow: "visible",
                boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                marginBottom: "75px",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "white",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: 500,
                  textTransform: "capitalize",
                  padding: "25px",
                  backgroundColor: "#009dff",
                  mb: 1,
                  borderRadius: "10px 10px 0px 0px",
                }}
              >
                {questions[currentQuestion - 1]?.subtype_name}
              </Typography>
              <div className="overonlinedi">
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      color: "#111827",
                      fontWeight: 600,
                      fontSize: "1.7rem",
                      marginBottom: "20px",
                    }}
                  >
                    Passage:
                  </div>
                  <Typography
                    className="readingpassage"
                    sx={{
                      height: {
                        xs: "30vh", // small screen
                        sm: "35vh",
                        md: "40vh",
                        lg: "45vh",
                      },
                      overflow: "scroll",
                      fontWeight: 400,
                      border: "1px solid #cecece",
                      padding: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        marginBottom: "20px",
                        fontSize: "16px",
                        fontWeight: "500",
                        whiteSpace: "break-spaces",
                        lineHeight: "1.625",
                      }}
                    >
                      {questions[currentQuestion - 1]?.prompt}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        marginBottom: "20px",
                        fontSize: "17px",
                        fontWeight: "500",
                        whiteSpace: "break-spaces",
                      }}
                    >
                      {questions[currentQuestion - 1]?.instruction}
                    </Typography>
                  </Typography>
                </div>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    width: "100%",
                    padding: "10px",
                  }}
                >
                  <div className="examscrollreading">
                    <Typography variant="h5">
                      <div
                        style={{
                          color: "#111827",
                          fontWeight: 600,
                          fontSize: "1.7rem",
                          marginBottom: "20px",
                        }}
                      >
                        Question:
                      </div>
                      <Typography
                        sx={{
                          fontSize: "1.4rem",
                          marginBottom: "20px",
                          textAlign: "left",
                          fontWeight: 500,
                        }}
                      >
                        {questions[currentQuestion - 1]?.question}
                      </Typography>

                      {questions[currentQuestion - 1]?.question_url && (
                        <Typography
                          variant="h5"
                          sx={{
                            marginBottom: "20px",
                            textAlign: "left",
                            position: "relative", // Ensure proper positioning of the image
                            overflow: "visible",
                            // Ensure the enlarged image is not clipped
                            "& img": {
                              maxWidth: "100%",
                              height:
                                List?.data?.question_by_type[0]
                                  ?.question_type_name === "Writing"
                                  ? "30rem"
                                  : "100%",
                              cursor: "pointer",

                              transition: "transform 0.3s ease",
                              position: "relative",
                              transformOrigin: "left center", // Keep the hover scaling aligned to the left
                            },
                            "& img:hover": {
                              transform: "scale(1.5)",
                            },
                          }}
                        >
                          <img src={imageFile} alt="Uploaded preview" />
                        </Typography>
                      )}

                      <div
                        style={{
                          color: "#111827",
                          fontWeight: 600,
                          fontSize: "1.7rem",
                          marginBottom: "20px",
                        }}
                      >
                        Select your answer:
                      </div>
                      <Typography
                        variant="h5"
                        sx={{
                          marginBottom: "20px",
                          textAlign: "justify",
                          whiteSpace: "break-spaces",
                        }}
                      >
                        {List?.data?.questions?.length === 0 ? (
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "larger",
                              marginTop: "30%",
                            }}
                          >
                            No Question Found
                          </div>
                        ) : (
                          renderQuestionOptions(
                            currentQuestion,
                            questions[currentQuestion - 1]?.question_type,
                            questions[currentQuestion - 1]?.options || [],
                            questions[currentQuestion - 1]?.optionsurl || []
                          )
                        )}{" "}
                      </Typography>
                      <Box sx={{ mb: 4, display: "flex", gap: 2 }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          startIcon={<FlagOutlinedIcon />}
                          sx={{
                            borderColor: "#ffffff",
                            color: isFlagged ? "#EA580C" : "#2196f3",
                            textTransform: "none",
                            fontWeight: 500,
                            py: 2,
                            px: 4,
                            fontSize: "14px",
                            borderRadius: "8px",
                            backgroundColor: isFlagged
                              ? "#FFF7ED"
                              : "transparent",
                            "&:hover": {
                              borderColor: isFlagged ? "#ffffff" : "#e5e7eb",
                              backgroundColor: isFlagged
                                ? "#38C172"
                                : "#e3f2fd",
                              color: isFlagged ? "#ffffff" : "#2196f3",
                            },
                          }}
                          onClick={() => {
                            dispatch(
                              addFalg({
                                student_test_id: ListStudentExam?.id,
                                question_id: questions[currentQuestion - 1]?.id,
                              })
                            );
                            setOpenflag(true);
                          }}
                        >
                          {isFlagged ? "Flagged for Review" : "Flag for Review"}
                        </Button>
                        {/* <Button color="primary">Flagged </Button> */}
                        {List?.data?.question_by_type[0]?.question_type_name ===
                        "Writing" ? null : (
                          <div style={{ display: "flex" }}>
                            <Button
                              variant={
                                isOptionSelected ? "contained" : "outlined"
                              }
                              sx={{
                                color: isOptionSelected ? "#fff" : "#767e89",
                                backgroundColor: isOptionSelected
                                  ? "#111"
                                  : "transparent",
                                borderColor: "#e5e7eb",
                                fontSize: "14px",
                                textTransform: "capitalize",
                                "&:hover": {
                                  backgroundColor: isOptionSelected
                                    ? "#222"
                                    : "#f5f5f5",
                                  color: isOptionSelected ? "#fff" : "#767e89",
                                },
                              }}
                              disabled={!isOptionSelected}
                              onClick={clearSelection}
                            >
                              Clear Answer
                            </Button>
                          </div>
                        )}
                      </Box>
                    </Typography>
                  </div>
                </Grid>
              </div>
            </Card>
            <Typography
              variant="body2"
              sx={{
                m: 3,
                fontSize: "14px",
                color: "#6b7280",
                textAlign: "center",
                paddingBottom: "80px",
              }}
            >
              Keyboard shortcuts: → / ← to navigate,
              <span className="key-style"> C</span> to clear answer
              <span className="key-style"> F</span> to flag answer
            </Typography>
          </>
        ) : questions[currentQuestion - 1]?.question_type === "Writing" ? (
          <>
            <Card
              sx={{
                margin:
                  questions[currentQuestion - 1]?.question_type === "Writing"
                    ? "2% 0%"
                    : "2% 9%",
                borderRadius:
                  questions[currentQuestion - 1]?.question_type === "Writing"
                    ? "0px"
                    : "12px",
                boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                overflow: "visible",
                height: "100%",
                marginBottom: "75px",
              }}
            >
              <div
                className="overonlin"
                style={{ display: "flex", height: "100%" }}
              >
                {/* Left Column - Scrollable Content */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    width: "50%",
                    borderRight: "1px solid #e4e4e4",
                    height: "100%",
                    overflowY: "auto", // Make this column scrollable
                  }}
                >
                  <Box sx={{ p: 2, backgroundColor: "#fff" }}>
                    {/* Header */}
                    <Typography
                      variant="h6"
                      sx={{
                        backgroundColor: "#009dff",
                        color: "#fff",
                        p: "10px",
                        borderRadius: 1,
                        mb: 2,
                        fontWeight: 500,
                      }}
                    >
                      Creative Writing
                    </Typography>

                    {/* Sub Header */}
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: "17px", mb: 2 }}
                    >
                      Use this idea as the basis for a piece of writing. You may
                      write in any style.
                    </Typography>

                    {/* Image Placeholder */}
                    <Paper
                      variant="outlined"
                      sx={{
                        height: "100%",
                        mb: 2,
                        borderRadius: 2,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#f9fafb",
                      }}
                    >
                      <Typography
                        sx={{ width: "100%", padding: "10px" }}
                        variant="body2"
                        color="text.secondary"
                      >
                        <img
                          src={imageFile}
                          alt="Zoomable"
                          style={{
                            height: "55rem",
                            width: "100%",
                            borderRadius: "8px",
                          }}
                        />
                      </Typography>
                    </Paper>

                    {/* Instruction Box */}
                    <Paper
                      elevation={0}
                      sx={{
                        backgroundColor: "#E9F4FF",
                        borderRadius: "8px",
                        borderLeft: "4px solid #009dff",
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#009dff",
                          width: "24px",
                          height: "24px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          flexShrink: 0,
                        }}
                      >
                        <ArticleOutlinedIcon fontSize="small" />
                      </Box>

                      <Typography fontSize="14px">
                        Look at the image above and write a creative piece
                        inspired by what you see. You may choose any writing
                        style - narrative, descriptive, persuasive, or
                        analytical.
                      </Typography>
                    </Paper>

                    {/* Counters */}
                    <Grid container spacing={2} mb={2} mt={0}>
                      {[
                        { label: "Words", value: wordCount },
                        { label: "Characters", value: characterCount },
                        { label: "Sentences", value: sentenceCount },
                        { label: "Paragraphs", value: paragraphCount },
                      ].map((item, index) => (
                        <Grid item xs={6} key={index}>
                          <Paper
                            elevation={0}
                            sx={{
                              backgroundColor: "#f9f9f9",
                              p: 2,
                              textAlign: "center",
                              borderRadius: 2,
                            }}
                          >
                            <Typography variant="h6" fontWeight={700}>
                              {item.value}
                            </Typography>
                            <Typography fontSize="13px">
                              {item.label}
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>

                    {/* Footer Note */}
                    {wordCount < 200 && (
                      <Box
                        sx={{
                          backgroundColor: "#FFEEDB",
                          color: "#C85A00",
                          p: 1,
                          borderRadius: 10,
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        Write between 200–300 words
                      </Box>
                    )}

                    {remainingWords > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                        }}
                      >
                        <ErrorOutlineIcon sx={{ color: "#f44336" }} />

                        <Typography
                          sx={{
                            color: "#f44336",
                            p: 1,
                            borderRadius: 10,
                            textAlign: "center",
                            fontSize: "14px",
                          }}
                        >
                          Need {remainingWords} more words
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Grid>

                {/* Right Column - Fixed Response Area */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    width: "50%",
                    borderRadius: "0 12px 12px 0", // <-- Add this line for right-side curve
                    overflow: "hidden", // Optional: ensures child corners are clipped
                  }}
                >
                  <div style={{ height: "100%" }}>
                    {/* <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: "17px", mb: 2, mt: 2 }}
                    >
                      Your Response:
                    </Typography> */}
                    <Box
                      sx={{
                        flex: 1,
                        px: 2, // Add padding to match left column
                        pb: 2,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          fontSize: "17px",
                          mb: 2,
                          mt: 2,
                          marginLeft: "5px",
                        }}
                      >
                        Your Response:
                      </Typography>
                      <Typography variant="h5">
                        <Typography
                          variant="h5"
                          sx={{
                            marginBottom: "20px",
                            textAlign: "justify",
                            whiteSpace: "break-spaces",
                          }}
                        >
                          {List?.data?.questions?.length === 0 ? (
                            <div
                              style={{
                                textAlign: "center",
                                fontSize: "larger",
                                marginTop: "30%",
                              }}
                            >
                              No Question Found
                            </div>
                          ) : (
                            renderQuestionOptions(
                              currentQuestion,
                              questions[currentQuestion - 1]?.question_type,
                              questions[currentQuestion - 1]?.options || [],
                              questions[currentQuestion - 1]?.optionsurl || []
                            )
                          )}
                        </Typography>
                      </Typography>
                    </Box>
                  </div>
                </Grid>
              </div>
            </Card>
          </>
        ) : (
          <Grid
            item
            xs={12}
            md={6}
            paddingBottom={"100px"}
            sx={{ margin: "0px 4% 10px 4%", height: "100%" }}
          >
            <Typography variant="h5">
              <Card
                sx={{
                  m: 2,
                  borderRadius: "20px",
                  boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "white",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight: 500,
                    textTransform: "capitalize",
                    padding: "25px",
                    backgroundColor: "#009dff",
                    mb: 1,
                  }}
                >
                  {questions[currentQuestion - 1]?.subtype_name}
                </Typography>
                <div style={{ margin: "2% 3%" }}>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, fontSize: "19px" }}
                  >
                    {questions[currentQuestion - 1]?.prompt}{" "}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, fontSize: "19px" }}
                  >
                    {questions[currentQuestion - 1]?.instruction}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, fontSize: "20px" }}
                  >
                    {questions[currentQuestion - 1]?.question}{" "}
                  </Typography>

                  {questions[currentQuestion - 1]?.question_url && (
                    <Box
                      sx={{
                        width: "100%",
                        bgcolor: "#f8f9fa",
                        borderRadius: "10px",
                        p: 2,
                        mb: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={imageFile}
                        alt="Abstract reasoning question"
                        style={{ width: "100%", maxWidth: "600px" }}
                      />
                    </Box>
                  )}
                  <Grid container spacing={2}>
                    {List?.data?.questions?.length === 0 ? (
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "larger",
                          marginTop: "30%",
                        }}
                      >
                        No Question Found
                      </div>
                    ) : (
                      renderQuestionOptions(
                        currentQuestion,
                        questions[currentQuestion - 1]?.question_type,
                        questions[currentQuestion - 1]?.options || [],
                        questions[currentQuestion - 1]?.optionsurl || []
                      )
                    )}
                  </Grid>

                  <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
                    {/* <Button color="primary">Flagged </Button> */}
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<FlagOutlinedIcon />}
                      sx={{
                        borderColor: "#ffffff",
                        color: isFlagged ? "#EA580C" : "#2196f3",
                        textTransform: "none",
                        fontWeight: 500,
                        borderRadius: "8px",
                        fontSize: "14px", // This should work for the button text
                        backgroundColor: isFlagged ? "#FFF7ED" : "transparent",
                        "&:hover": {
                          borderColor: isFlagged ? "#ffffff" : "#e5e7eb",
                          backgroundColor: isFlagged ? "#38C172" : "#e3f2fd",
                          color: isFlagged ? "#ffffff" : "#2196f3",
                        },
                      }}
                      onClick={() => {
                        dispatch(
                          addFalg({
                            student_test_id: ListStudentExam?.id,
                            question_id: questions[currentQuestion - 1]?.id,
                          })
                        );
                        setOpenflag(true);
                      }}
                    >
                      {isFlagged ? "Flagged for Review" : "Flag for Review"}
                    </Button>
                    {List?.data?.question_by_type[0]?.question_type_name ===
                    "Writing" ? null : (
                      <div style={{ display: "flex" }}>
                        <Button
                          variant={isOptionSelected ? "contained" : "outlined"}
                          sx={{
                            color: isOptionSelected ? "#000" : "#767e89",
                            backgroundColor: "transparent",
                            borderColor: "#e5e7eb",
                            fontSize: "14px",
                            textTransform: "capitalize",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                              color: isOptionSelected ? "#36454F" : "#767e89",
                            },
                          }}
                          disabled={!isOptionSelected}
                          onClick={clearSelection}
                        >
                          Clear Answer
                        </Button>
                      </div>
                    )}
                  </Box>
                </div>
              </Card>
              <Typography
                variant="body2"
                sx={{
                  m: 3,
                  fontSize: "14px",
                  color: "#6b7280",
                  textAlign: "center",
                  paddingBottom: "80px",
                }}
              >
                Keyboard shortcuts: <span className="key-style"> ←/→ </span> to
                navigate,
                <span className="key-style"> C</span> to clear answer
                <span className="key-style"> F</span> to flag answer
              </Typography>
            </Typography>
          </Grid>
        )}

        {/* 
            {/* submit exam popup */}
        <MessageDialogTest
          messageheading={"Test Summary"}
          questioncount={Add?.skipped_questions}
          listcount={Add?.skipped_question_numbers}
          questioncountflag={flag?.length}
          listcountflag={Add?.flagged_question_numbers}
          messageableName={"Please review your test before submitting."}
          open={isSubmitted}
          setOpen={setIsExamOver}
          exam_id={exam_id?.examID}
          valueofdata={ListStudentExam?.id}
          setIsSubmitted={setIsSubmitted}
          setIspopup={setOpen}
          student_exam_id={ListStudentExam?.id}
          remaining_time={timing}
          question_type_id={questions[currentQuestion - 1]?.question_type_id}
          Question_id={questions[currentQuestion - 1]?.question_id}
          condition={
            List?.data?.question_by_type[0]?.question_type_name === "Writing"
          }
          writingSentence={editorValue}
        />

        {/* time up message  */}
        <AlterDialog
          alterheading={"Time’s Up!"}
          alterableName={
            currentQuestionTypeIndex < List?.data?.question_by_type?.length - 1
              ? "The allocated time for this section has ended. You are now being moved to the next section. Your responses for this section have been saved automatically."
              : "The allocated time for this section has ended. You will now be redirected to the result page. Your responses have been saved automatically."
          }
          altermessage={
            currentQuestionTypeIndex < List?.data?.question_by_type?.length - 1
              ? "Please proceed to the next section."
              : "Please wait while we calculate your results."
          }
          open={istimeOver}
          setOpen={setIstimeOver}
          valueofdata={ListStudentExam?.id}
          buttonname={
            <>
              <ButtonField
                className="alter_button"
                onClick={() => {
                  if (
                    currentQuestionTypeIndex <
                    List?.data?.question_by_type?.length - 1
                  ) {
                    setCurrentQuestionTypeIndex((prev) => prev + 1);
                  } else {
                    navigate("/examresultpractice", {
                      state: {
                        id: ListStudentExam?.id,
                        type:
                          List?.data?.question_by_type[0]
                            ?.question_type_name === "Writing"
                            ? "writing"
                            : "regular",
                        showSubmitAlert: true,
                      },
                    });
                  }
                  dispatch(PopupStudentExam({ closed: false }));

                  setIstimeOver(false);
                }}
              >
                {currentQuestionTypeIndex <
                List?.data?.question_by_type?.length - 1
                  ? "Continue"
                  : "Proceed"}
              </ButtonField>
            </>
          }
        />
        <AlterDialog
          alterheading={"Warning"}
          alterableName={
            "Your answers have not been saved. Are you sure you want to close?. Are you sure you want to close?."
          }
          open={showModal}
          setOpen={setShowModal}
          buttonname={
            <>
              <ButtonField
                className="form_save_button"
                onClick={() => {
                  setShowModal(false);
                  window.location.reload(); // Or navigate to a different page if needed
                }}
              >
                Yes
              </ButtonField>
              <ButtonField
                className="form_cancel_button"
                onClick={() => {
                  setShowModal(false);
                }}
              >
                No
              </ButtonField>
            </>
          }
        />

        <Snackbar
          anchorOrigin={anchorPosition}
          open={lastMinters}
          onClose={() => {
            setLastMinters(false);
          }}
          sx={{
            "& .MuiSnackbarContent-root": {
              backgroundColor: "#4d7aa3", // Background color of the Snackbar content
              color: "white", // Text color
            },
          }}
          message={
            <span style={{ display: "flex", alignItems: "center" }}>
              <WarningAmberIcon style={{ marginRight: "8px" }} />
              Last 3 Minutes
            </span>
          }
          key={`${anchorPosition.vertical}-${anchorPosition.horizontal}`}
          autoHideDuration={3000} // Snackbar will close automatically after 3 seconds
        />
      </div>
      <div className="navigation-buttons">
        <Button
          className="buttonnameprevious"
          sx={{
            // color: "#009dff", // Blue text
            backgroundColor: "#fff", // White background
            // border: "2px solidrgb(160, 160, 160)", // Blue border, thicker
            borderRadius: "12px",
            boxShadow: "none",
            fontWeight: 500,
            fontSize: "16px",
            padding: "8px 24px",
            minWidth: "120px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#f5f9ff",
              borderColor: "#009dff",
            },
          }}
          onClick={() => setCurrentQuestion((prev) => Math.max(prev - 1, 1))}
          disabled={currentQuestion === 1}
        >
          <ArrowBackIcon sx={{ marginRight: "10px", color: "black" }} />{" "}
          Previous
        </Button>

        {currentQuestion === questions?.length ? (
          currentQuestionTypeIndex <
          List?.data?.question_by_type?.length - 1 ? (
            // <Button
            //   className="buttonnamenext"
            //   variant="contained"
            //   color="primary"
            //   onClick={() => {
            //     if (
            //       filterquestionlist?.length > 0 &&
            //       filterquestionlist[0]?.id
            //     ) {
            //       dispatch(
            //         addExamAnswerPractice({
            //           id: filterquestionlist[0]?.id,
            //           student_test_id: ListStudentExam?.id,
            //           question_id: questions[currentQuestion - 1]?.id,
            //           option_id: selectedOptionFilterValue
            //             ? selectedOptionFilterValue[0]?.option_id
            //             : null,
            //           remaining_time: timing,
            //           skipped: !selectedOptionFilterValue[0]?.option_id,
            //           question_type_id:
            //             questions[currentQuestion - 1]?.question_type_id,
            //         })
            //       );
            //     } else {
            //       dispatch(
            //         addExamAnswerPractice({
            //           student_test_id: ListStudentExam?.id,
            //           question_id: questions[currentQuestion - 1]?.id,
            //           option_id: selectedOptionFilterValue
            //             ? selectedOptionFilterValue[0]?.option_id
            //             : null,
            //           remaining_time: timing,
            //           skipped: !selectedOptionFilterValue[0]?.option_id,
            //           question_type_id:
            //             questions[currentQuestion - 1]?.question_type_id,
            //         })
            //       );
            //     }
            //     setIsSection(true);
            //   }}
            // >
            //   Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
            // </Button>
            <Button
              className="buttonnamenext"
              sx={{ zIndex: 1111 }}
              onClick={() => {
                const currentQuestionId = questions[currentQuestion - 1]?.id;
                const questionTypeId =
                  questions[currentQuestion - 1]?.question_type_id;
                const optionId =
                  selectedOptionFilterValue?.[0]?.option_id ?? null;
                const isSkipped = !selectedOptionFilterValue?.[0]?.option_id;
                const currentTime = new Date().toISOString();

                const payload = {
                  student_test_id: ListStudentExam?.id,
                  question_id: currentQuestionId,
                  option_id: optionId,
                  remaining_time: timing,
                  skipped: isSkipped,
                  question_type_id: questionTypeId,
                  question_start_time: questionStartTime,
                  question_end_time: currentTime,
                };

                if (
                  filterquestionlist?.length > 0 &&
                  filterquestionlist[0]?.id
                ) {
                  dispatch(
                    addExamAnswerPractice({
                      id: filterquestionlist[0]?.id,
                      ...payload,
                    })
                  );
                } else {
                  dispatch(addExamAnswerPractice(payload));
                }

                // Move to next question
                setCurrentQuestion((prev) =>
                  Math.min(prev + 1, questions?.length)
                );
              }}
              disabled={currentQuestion === questions?.length}
            >
              Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
            </Button>
          ) : (
            // <Button
            //   className="buttonnamenext"
            //   variant="contained"
            //   color="primary"
            //   title={
            //     List?.data?.question_by_type[0]?.question_type_name ===
            //     "Writing"
            //       ? "200 Words to must"
            //       : ""
            //   }
            //   disabled={
            //     List?.data?.question_by_type[0]?.question_type_name ===
            //       "Writing" && wordCount < 200
            //   }
            //   onClick={() => {
            //     if (
            //       List?.data?.question_by_type[0]?.question_type_name !==
            //       "Writing"
            //     ) {
            //       if (
            //         filterquestionlist?.length > 0 &&
            //         filterquestionlist[0]?.id
            //       ) {
            //         dispatch(
            //           addExamAnswerPractice({
            //             id: filterquestionlist[0]?.id,
            //             student_test_id: ListStudentExam?.id,
            //             question_id: questions[currentQuestion - 1]?.id,
            //             option_id: selectedOptionFilterValue
            //               ? selectedOptionFilterValue[0]?.option_id
            //               : null,
            //             remaining_time: timing,
            //             skipped: !selectedOptionFilterValue[0]?.option_id,
            //             question_type_id:
            //               questions[currentQuestion - 1]?.question_type_id,
            //           })
            //         );
            //       } else {
            //         dispatch(
            //           addExamAnswerPractice({
            //             student_test_id: ListStudentExam?.id,
            //             question_id: questions[currentQuestion - 1]?.id,
            //             option_id: selectedOptionFilterValue
            //               ? selectedOptionFilterValue[0]?.option_id
            //               : null,
            //             remaining_time: timing,
            //             skipped: !selectedOptionFilterValue[0]?.option_id,
            //             question_type_id:
            //               questions[currentQuestion - 1]?.question_type_id,
            //           })
            //         );
            //       }
            //     }
            //     dispatch(
            //       listExamsubmitPractice({
            //         id: ListStudentExam?.id,
            //       })
            //     );

            //     setIsSubmitted(true);
            //   }}
            // >
            //   Submit Test
            // </Button>
            <Button
              className="buttonnamenext"
              variant="contained"
              color="primary"
              title={
                List?.data?.question_by_type[0]?.question_type_name ===
                "Writing"
                  ? "120 Words to must"
                  : ""
              }
              disabled={
                List?.data?.question_by_type[0]?.question_type_name ===
                  "Writing" && wordCount < 120
              }
              onClick={async () => {
                const currentTime = new Date().toISOString();

                try {
                  // For non-Writing questions, wait for addExamAnswerPractice to complete
                  if (
                    List?.data?.question_by_type[0]?.question_type_name !==
                    "Writing"
                  ) {
                    const payload = {
                      student_test_id: ListStudentExam?.id,
                      question_id: questions[currentQuestion - 1]?.id,
                      option_id:
                        selectedOptionFilterValue?.[0]?.option_id ?? null,
                      remaining_time: timing,
                      skipped: !selectedOptionFilterValue?.[0]?.option_id,
                      question_type_id:
                        questions[currentQuestion - 1]?.question_type_id,
                      question_start_time: questionStartTime,
                      question_end_time: currentTime,
                    };

                    if (
                      filterquestionlist?.length > 0 &&
                      filterquestionlist[0]?.id
                    ) {
                      await dispatch(
                        addExamAnswerPractice({
                          id: filterquestionlist[0]?.id,
                          ...payload,
                        })
                      );
                    } else {
                      await dispatch(addExamAnswerPractice(payload));
                    }
                  }

                  // Wait for exam submission to complete
                  await dispatch(
                    listExamsubmitPractice({ id: ListStudentExam?.id })
                  );

                  // Only set to true after both API calls complete successfully
                  setIsSubmitted(true);
                } catch (error) {
                  console.error("Error in submission process:", error);
                  // Handle error (show message to user, etc.)
                }
              }}
            >
              Submit Test
            </Button>
          )
        ) : (
          // <Button
          //   className="buttonnamenext"
          //   sx={{ zIndex: 1111 }}
          //   onClick={() => {
          //     setCurrentQuestion((prev) =>
          //       Math.min(prev + 1, questions?.length)
          //     );
          //     if (filterquestionlist?.length > 0 && filterquestionlist[0]?.id) {
          //       dispatch(
          //         addExamAnswerPractice({
          //           id: filterquestionlist[0]?.id,
          //           student_test_id: ListStudentExam?.id,
          //           question_id: questions[currentQuestion - 1]?.id,
          //           option_id: selectedOptionFilterValue
          //             ? selectedOptionFilterValue[0]?.option_id
          //             : null,
          //           remaining_time: timing,
          //           skipped: !selectedOptionFilterValue[0]?.option_id,
          //           question_type_id:
          //             questions[currentQuestion - 1]?.question_type_id,
          //         })
          //       );
          //     } else {
          //       dispatch(
          //         addExamAnswerPractice({
          //           student_test_id: ListStudentExam?.id,
          //           question_id: questions[currentQuestion - 1]?.id,
          //           option_id: selectedOptionFilterValue
          //             ? selectedOptionFilterValue[0]?.option_id
          //             : null,
          //           remaining_time: timing,
          //           skipped: !selectedOptionFilterValue[0]?.option_id,
          //           question_type_id:
          //             questions[currentQuestion - 1]?.question_type_id,
          //         })
          //       );
          //     }
          //   }}
          //   disabled={currentQuestion === questions?.length}
          // >
          //   Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
          // </Button>
          <Button
            className="buttonnamenext"
            sx={{ zIndex: 1111 }}
            onClick={() => {
              const currentQuestionId = questions[currentQuestion - 1]?.id;
              const questionTypeId =
                questions[currentQuestion - 1]?.question_type_id;
              const optionId =
                selectedOptionFilterValue?.[0]?.option_id ?? null;
              const isSkipped = !selectedOptionFilterValue?.[0]?.option_id;
              const currentTime = new Date().toISOString();

              const payload = {
                student_test_id: ListStudentExam?.id,
                question_id: currentQuestionId,
                option_id: optionId,
                remaining_time: timing,
                skipped: isSkipped,
                question_type_id: questionTypeId,
                question_start_time: questionStartTime,
                question_end_time: currentTime,
              };

              if (filterquestionlist?.length > 0 && filterquestionlist[0]?.id) {
                dispatch(
                  addExamAnswerPractice({
                    id: filterquestionlist[0]?.id,
                    ...payload,
                  })
                );
              } else {
                dispatch(addExamAnswerPractice(payload));
              }

              // Move to next question
              setCurrentQuestion((prev) =>
                Math.min(prev + 1, questions?.length)
              );
            }}
            disabled={currentQuestion === questions?.length}
          >
            Next <ArrowForwardIcon sx={{ marginLeft: "10px" }} />
          </Button>
        )}
      </div>
      <CustomSnackBox>
        {(showAlert) => (
          <>
            <SnackTriggerHandler
              showAlert={showAlert}
              openflag={openflag}
              setOpenflag={setOpenflag}
              showClearAlert={showClearAlert}
              setShowClearAlert={setShowClearAlert}
              showUnflagAlert={showUnflagAlert}
              setShowUnflagAlert={setShowUnflagAlert}
              isFlagged={isFlagged}
            />
          </>
        )}
      </CustomSnackBox>
    </>
  );
};

export default OnlineExamPracticeReExam;
